<button mat-icon-button>
	<div class="line1"></div>
	<div class="line2"></div>
	<div class="line3"></div>
</button>
